import React, { createContext, useContext } from "react";

export const CraftStoreContext = createContext({
  products: [],
  onAddToCart: null,
  bussinessUuid: null,
  displayBusinessName: "",
  previewMode: false,
  isLiveStorefront: false,
});

export const useCraftStore = () => useContext(CraftStoreContext);
